import type { PromptResolve } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { RegularModal, TextArea } from '@/components_deprecated'

export interface ViewCommentModalProps {
  onClose: PromptResolve<boolean | null>
  comment: string
}

export const ViewCommentModal: React.JSX.CFC<ViewCommentModalProps> = ({
  onClose,
  comment,
}) => {
  const translations = useTranslate({
    comment: 'common.comment',
    close: 'common.close',
  })

  return (
    <RegularModal
      title={translations.comment}
      width="600px"
      onCancel={() => onClose(null)}
      cancelText={translations.close}
      cancelOnClickOutside={true}
    >
      <TextArea
        onChange={() => void 0}
        value={comment}
        height="200px"
        fullWidth
        disabled
      />
    </RegularModal>
  )
}
